export enum ViewType {
    Card,
    Table,
}

export enum ViewTypeForPageLoad {
    CARD_VIEW = 'Card view',
    TABLE_VIEW = 'Table view',
}
